import { Plus, UserPlus, Building2, Briefcase, FileSignature, CheckSquare, Mail } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CONTRACT_BUILDER_ENABLED } from "@/lib/flags";
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
} from "@/components/ui/dropdown-menu";

// Top-bar primary "+ Create" entry point per MASTER_PROMPT §2.2.
// Routes intentionally land on the list page with a `?new=1` query param —
// each list owns its own creation flow (drawer, modal, inline row), so this
// is just the global shortcut to invoke that flow no matter where you are.

const CREATE_ITEMS = [
  { label: "Contact", icon: UserPlus, to: "/contacts?new=1" },
  { label: "Company", icon: Building2, to: "/companies?new=1" },
  { label: "Deal", icon: Briefcase, to: "/deals?new=1" },
  { label: "Contract", icon: FileSignature, to: "/contracts?new=1" },
] as const;

const ACTION_ITEMS = [
  { label: "Task", icon: CheckSquare, to: "/tasks?new=1" },
  { label: "Sequence", icon: Mail, to: "/sequences?new=1" },
] as const;

export default function CreateMenu() {
  const navigate = useNavigate();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="primary" size="md" className="gap-1">
          <Plus className="h-3.5 w-3.5" />
          <span className="hidden sm:inline">Create</span>
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52">
        <DropdownMenuLabel className="text-xs text-text-3">Records</DropdownMenuLabel>
        {CREATE_ITEMS.filter((item) => CONTRACT_BUILDER_ENABLED || item.to !== "/contracts?new=1").map((item) => (
          <DropdownMenuItem
            key={item.label}
            onClick={() => navigate(item.to)}
            className="gap-2 text-base"
          >
            <item.icon className="h-3.5 w-3.5 text-text-2" />
            {item.label}
          </DropdownMenuItem>
        ))}
        <DropdownMenuSeparator />
        <DropdownMenuLabel className="text-xs text-text-3">Actions</DropdownMenuLabel>
        {ACTION_ITEMS.map((item) => (
          <DropdownMenuItem
            key={item.label}
            onClick={() => navigate(item.to)}
            className="gap-2 text-base"
          >
            <item.icon className="h-3.5 w-3.5 text-text-2" />
            {item.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
